<template>
  <div>
<div class="main-content mt-150" v-if="successSubscribe">
    <div class="container">
      <!-- Section Content -->
      <div class="section-content">
        <div class="row">
          <div class="col-md-12">
            <h2 class="text-theme-colored text-center">GRAZIE PER L'ISCRIZIONE</h2>
            <h5 class="text-center">
              VERIFICA LA TUA MAIL ED EFFETTUA L'ACCESSO ALL'AREA PERSONALE, INIZIA IL TUO ALLENAMENTO CON IL 
              <span class="text-theme-colored">PROGRAMMA GRATUITO</span>
            </h5>
          </div>
        </div>
      </div>
    </div>
    </div>


  <div class="main-content mt-150" v-if="!successSubscribe">
    <div class="container">
      <!-- Section Content -->
      <div class="section-content">
        <div class="row">
          <div class="col-md-12">
            <h2 class="text-theme-colored text-center">ISCRIVITI</h2>
            <h5 class="text-center">
              ACCEDI ALL'AREA PERSONALE CON UN
              <span class="text-theme-colored">PROGRAMMA GRATUITO</span>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <!-- Divider: Contact -->
    <section class="divider">
      <div class="container">
        <form
        @submit.prevent="submitSubscribe"
          id="subscribe_form"
          class="needs-validation"
          name="subscribe_form"
          novalidate
        >
          <div v-if="!loggedIn">
            <div class="row">
              <div class="form-group col-md-6">
                <label>Nome e secondo nome</label>
                <input
                  type="text"
                  v-model="register.name"
                  required
                  class="form-control"
                />
              </div>
              <div class="form-group col-md-6">
                <label>Cognome</label>
                <input
                  type="text"
                  v-model="register.surname"
                  required
                  class="form-control"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label>Numero di telefono</label>
                <input
                  type="phone"
                  v-model="register.phone"
                  id="phoneField"
                  required
                  class="form-control"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label>Email</label>
                <input
                  type="email"
                  v-model="register.email"
                  id="emailField"
                  required
                  class="form-control"
                />
              </div>
              <div class="form-group col-md-12" v-if="!register.isGift">
                <label>Conferma Email</label>
                <input
                  type="email"
                  v-model="register.emailRepeat"
                  id="emailRepeatField"
                  required
                  class="form-control"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-check col-md-12">
                <input
                  type="checkbox"
                  required
                  v-model="register.privacy"
                  class="form-check-input"
                  id="chkPrivacy"
                />
                <label class="form-check-label" for="chkPrivacy"
                  >Accetto le condizioni di privacy
                  <a class="text-theme-colored" target="_blank" href="/privacy"
                    >Leggi qui</a
                  ></label
                >
              </div>
              <div class="form-check col-md-12">
                <input
                  type="checkbox"
                  v-model="register.condition"
                  required
                  class="form-check-input"
                  id="chkConditions"
                />
                <label class="form-check-label" for="chkConditions"
                  >Accetto i termini e condizioni
                  <a class="text-theme-colored" target="_blank" href="/terms"
                    >Leggi qui</a
                  ></label
                >
              </div>
            </div>
          </div>

          <div class="row pt-20">
            <div class="col-12 d-flex justify-content-center">
              <div ref="turnstile"></div>
            </div>
          </div>

          <div class="row pt-10">
            <div class="alert alert-danger" v-if="error">{{ error }}</div>
          </div>

          <div class="row pt-20">
            <div class="col-12 text-center">
              <button
                type="submit"
                :disabled="submitting"
                class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white"
              >
                {{ submitting ? "ATTENDI..." : "ISCRIVITI" }}
              </button>
            </div>
          </div>

         
        </form>
      </div>
    </section>
  </div>
</div>
</template>
  
  <style scoped>
#subscribe_form.was-validated .form-control:invalid {
  border-color: #ee163b;
}

#subscribe_form.was-validated .form-check-input:invalid {
  outline: 2px solid red;
}

.form-check-input {
  margin-right: 1rem;
  width: 1.2rem;
  height: 1.2rem;
}

.form-check-label {
  vertical-align: super;
}

.text-line-through {
  text-decoration: line-through;
}

.item .class-item {
  border-radius: 5px;
}

a.btn.disabled {
  background-color: #b3b3b3;
  border-color: #b3b3b3;
}
</style>
  
  <script>
import axios from "axios";
import turnstile from "../helper/turnstile";

export default {
  name: "Subscribe",
  mixins: [turnstile],
  data() {
    return {
      program: null,
      monthSelected: 1,
      baseUrl: process.env.VUE_APP_API_URL,
      loggedIn:
        localStorage.getItem("token") != undefined ||
        localStorage.getItem("token") != null,
      error: "",
      successSubscribe: false,
      submitting: false,
      register: {
        email: "",
        emailRepeat: "",
        phone: "",
        name: "",
        surname: "",
        privacy: false,
        condition: false,
      },
    };
  },
  methods: {
    submitSubscribe: function (e) {
      e.preventDefault();

      this.error = "";

      if (
        this.register.name == "" || this.register.surname== ""){
            this.error = "Inserisci un nome utente";
            return;
        }

      if (
        this.register.email == "" || this.register.emailRepeat== ""){
            this.error = "Inserisci un email valida";
            return;
        }

        const regex = /^(\+?\d{1,4}[\s-]?)?(\(?\d{1,4}\)?[\s-]?)?\d{1,4}[\s-]?\d{1,4}[\s-]?\d{1,9}$/;

      if (
        this.register.phone == "" || !regex.test(this.register.phone)){
            this.error = "Inserisci un numero di telefono valido";
            return;
        }
        

          
      if (
        !this.register.privacy || !this.register.condition){
            this.error = "Accetta privacy e condizioni";
            return;
        }

      if (this.turnstileMissing()) {
        this.error = "Completa la verifica di sicurezza qui sopra";
        return;
      }

      if (
        this.register.email != "" &&
        this.register.email == this.register.emailRepeat &&
        this.register.name != "" &&
        this.register.phone != "" &&
        this.register.surname != ""
      ) {
        this.submitting = true;

        axios
          .post(
            process.env.VUE_APP_API_URL + "/checkoutTrialProgram",
            this.withTurnstileToken(this.register)
          )
          .then((response) => {
            console.log(response.data.Ok);
            if (response.data.Ok == true) {
              this.successSubscribe = true;
            }
            else if(response.data.Error != ""){
this.error = response.data.Error;
            }
          })
          .catch((err) => {
            console.log(err);
            // Il backend risponde 400/403/429 con un messaggio da mostrare
            // (verifica non superata, troppi tentativi).
            var serverError =
              err.response && err.response.data && err.response.data.Error;

            this.error =
              serverError ||
              "Iscrizione non riuscita, riprova tra qualche minuto.";
          })
          .then(() => {
            this.submitting = false;
            // Il token Turnstile e' usa e getta: dopo ogni tentativo
            // il widget va rigenerato, altrimenti il secondo invio fallisce.
            this.resetTurnstile();
          });
      }
    },
  },
  mounted() {
    if (this.loggedIn) {
      window.location.replace("/");
      return;
    }

    this.loadTurnstile();
  },
};
</script>